export enum Status {
    NonCarrier = 0,
    Carrier,
    Affected,
    Null
}

export enum FinalStatus {
    NonCarrier = 0,
    CarrierFromMother,
    CarrierFromFather,
    Affected,
    Null
}

export enum DirectTestingStatus {
    Status = 0,
    NonCarrier,
    Carrier,
    Affected,
    Inconclusive
}

export const statusTitle = (): Record<Status, string> => ({
    [Status.NonCarrier]: "Non Carrier",
    [Status.Carrier]: "Carrier",
    [Status.Affected]: "Affected",
    [Status.Null]: "Unknown"
})

export const finalStatusTitle = (): Record<FinalStatus, string> => ({
    [FinalStatus.NonCarrier]: "Non Carrier",
    [FinalStatus.CarrierFromMother]: "Carrier from Mother",
    [FinalStatus.CarrierFromFather]: "Carrier from Father",
    [FinalStatus.Affected]: "Affected",
    [FinalStatus.Null]: "Unknown"
})

export const directTestingStatusTitle = (): Record<DirectTestingStatus, string> => ({
    [DirectTestingStatus.Status]: "Status",
    [DirectTestingStatus.NonCarrier]: "Non Carrier",
    [DirectTestingStatus.Carrier]: "Carrier",
    [DirectTestingStatus.Inconclusive]: "Inconclusive",
    [DirectTestingStatus.Affected]: "Affected"

})